var _radialGradient, _circle, _radialGradient2, _path, _radialGradient3, _path2, _radialGradient4, _path3, _circle2, _path4, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisappointedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "6RfME4lB62ffUFLP0Lwesa",
    cx: 160,
    cy: 24,
    r: 18,
    fx: 159.905,
    fy: 16.289,
    gradientTransform: "translate(-136)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#f8b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c0c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#6RfME4lB62ffUFLP0Lwesa)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "6RfME4lB62ffUFLP0Lwesb",
    cx: -159.728,
    cy: -3.574,
    r: 3.326,
    gradientTransform: "matrix(.0157 1.116 -3.2952 .1212 14.724 210.401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#6RfME4lB62ffUFLP0Lwesb)",
    d: "M19.17,34.252c0,0,1.116,0.748,4.83,0.748c3.44,0,4.827-0.748,4.827-0.748 s-0.863-1.485-4.827-1.485S19.17,34.252,19.17,34.252z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "6RfME4lB62ffUFLP0Lwesc",
    cx: 1364.189,
    cy: -1072.793,
    r: 8.277,
    gradientTransform: "matrix(-.618 0 0 -.3776 867.052 -372.304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#6RfME4lB62ffUFLP0Lwesc)",
    d: "M24,34c3.392,0,4.31,0.609,4.31,0.609S27.43,36,24,36s-4.31-1.391-4.31-1.391S20.608,34,24,34 z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "6RfME4lB62ffUFLP0Lwesd",
    cx: -1782.926,
    cy: -855.625,
    r: 15.654,
    gradientTransform: "matrix(.35 0 0 -.1877 648.002 -127.043)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#6RfME4lB62ffUFLP0Lwesd)",
    d: "M28.701,34.195c0.501,0.276,0.995-0.358,0.608-0.779C28.185,32.194,26.458,31,24,31 s-4.185,1.194-5.309,2.416c-0.387,0.421,0.107,1.055,0.608,0.779C20.45,33.559,22.024,33,24,33S27.55,33.559,28.701,34.195z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 23.5,
    r: 0.5,
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M34.5,25c0,0-0.875,0.005-1.656,0.005c-2.343,0-5.102-1.944-5.102-1.944l-0.682,0.668 c0,0,1.07,3.271,3.94,3.271c2.124,0,3.773-1.08,3.773-1.08L34.5,25z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 25.5,
    r: 0.5,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 23.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M13.5,25c0,0,0.875,0.005,1.656,0.005c2.343,0,5.102-1.944,5.102-1.944l0.682,0.668 c0,0-1.07,3.271-3.94,3.271c-2.124,0-3.773-1.08-3.773-1.08L13.5,25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 25.5,
    r: 0.5,
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisappointedFace);
export default __webpack_public_path__ + "static/media/disappointed-face.65378073771744834b270a94fd3556fe.svg";
export { ForwardRef as ReactComponent };